export function hapticSave() {
  navigator.vibrate?.([50]);
}
